import {ReportName} from 'common/report/constants';
import {ReportHeader, ReportHeaderJsxProps} from 'common/report/report-manager/report-header';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {ChartType, ConversionWindowUnit, FunnelBookmark} from 'common/report/funnels/models/types';
import {FunnelsQuery} from 'common/report/funnels/models/funnels-query';
import {HeaderCustomAlertParams} from 'common/query-builder/query-report-header/types';
import {encode} from 'common/report/funnels/util/funnels-url';
import {FunnelQueryResponse} from 'common/report/funnels/models/api-types';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';

import {getAlertKeyValues} from '../models/utils';

export class FunnelsReportHeader extends ReportHeader<FunnelBookmark, FunnelQueryResponse> {
  displayContext = SearchDisplayContext.Funnels;
  reportType = ReportName.Funnels;
  customAlertsEnabled = true;
  csvExportEnabled = true;

  public reportHeaderCustomAlertParams(): HeaderCustomAlertParams {
    const funnelQuery = FunnelsQuery.fromBookmark(this.bookmark.params);
    const {chartType, conversionWindow} = funnelQuery;
    const customAlertsDisabledText =
      chartType === ChartType.Trends && conversionWindow.unit === ConversionWindowUnit.Session
        ? `Alerts are not supported when the conversion window is measured in sessions.`
        : ``;
    const dateRange = DateRange.fromBookmarkFormat(this.bookmark.params.date_range);

    return {
      customAlertsDisabledText,
      isCustomAlertsActionVisible: true,
      resultsKeysAndValues: getAlertKeyValues(funnelQuery, this.results),
      customAlertIntervalDays: dateRange.getIntervalDays(),
    };
  }

  getInvalidParamsMessage(): string {
    if (!FunnelsQuery.fromBookmark(this.bookmark.params).isValidForQuery()) {
      return `Please select at least two steps to save your funnel report`;
    }

    return null;
  }

  getStandaloneHash(titleOverride?: string) {
    const urlParams = {
      query: FunnelsQuery.fromBookmark(this.bookmark.params),
      ...(titleOverride ? {title: titleOverride} : {}),
    };
    const stringifiedBookmark = encode(urlParams, {version: 2});
    if (this.bookmark.id && !titleOverride) {
      return `report/${this.bookmark.id}/${stringifiedBookmark}`;
    }

    return `view/${stringifiedBookmark}`;
  }
}

export const FunnelsReportHeaderEl = defineAndMakeJsxFactory<ReportHeaderJsxProps>(
  `funnels-report-header`,
  FunnelsReportHeader,
);
export const FunnelsReportHeaderReact = panel2react<ReportHeaderJsxProps>(`funnels-report-header`, FunnelsReportHeader);
